import React from 'react';

const Mensageria: React.FC = () => {
    return <h1>Mensageria</h1>;
};

export default Mensageria;
